<template>
    <div class="add-favorites">
        <h3>{{ $TL.addFavorites }}</h3>
        <div class="create-favor-box">
            <!-- 判断最新创建还是已有收藏夹 -->
            <div class="first-create-info" v-if="hasFavoritesList === 'no'">
                <div class="info-box">
                    <h3>{{ $TL.startYourFirstFavorite }}</h3>
                    <p>{{ $TL.useFavoritestoSave }}</p>
                    <v-btn
                        class="def gradient-bg"
                        @click="open_create_favorites_model"
                        >{{ $TL.createFavorite }}</v-btn
                    >
                </div>
            </div>
            <div class="favor-list" v-else-if="hasFavoritesList === 'yes'">
                <ul class="list scrollbar" ref="favorList">
                    <!-- todo 循环 -->
                    <li
                        :class="['favor-items', index === i && 'active']"
                        v-for="(item, i) in firstCreatList"
                        :key="i"
                        @click="choice_favor(i, item.id)"
                    >
                        <v-btn
                            class="favor-cover"
                            :style="
                                item.cover &&
                                    `background-image:url(${item.cover[0]});`
                            "
                        >
                            <v-icon v-if="index === i">mdi-check</v-icon>
                        </v-btn>
                        <p class="f-name">{{ item.name }}</p>
                    </li>
                </ul>
            </div>
            <div class="loading-box" v-else>
                <v-icon>mdi-loading</v-icon>
            </div>
        </div>
        <div class="operat-btm">
            <v-btn
                class="create-favorite-btn"
                @click="open_create_favorites_model"
            >
                <v-icon>mdi-plus-circle</v-icon>{{ $TL.newFavorite }}
            </v-btn>
            <v-btn
                class="cancel-favorite-btn def"
                v-if="currentPictureFavorite"
                @click="cancel_favorite"
                >{{ $TL.unfavorite }}</v-btn
            >
            <v-btn
                class="save-btn def gradient-bg"
                @click="save_favorite"
                v-if="!submit"
                >{{ $TL.save }}</v-btn
            >
            <span class="save-suss-btn" v-if="submit">
                <v-icon v-if="load" class="load">mdi-reload</v-icon>
                <v-icon v-else-if="error" class="errors">mdi-close</v-icon>
                <v-icon v-else class="suss">mdi-check-circle</v-icon>
                saved
            </span>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
    getFavorites,
    getUserProfile,
    cancelPictureFavorite
} from "@/api/interface.js";
import { postRequest } from "@/api/configs.js";
import { timeout } from "@/utils/util.js";
export default {
    name: "add-favorites",

    data() {
        return {
            favoriteName: "",
            newFavoriteId: 0,
            currentFavm: 0,
            hasFavoritesList: null,
            firstCreatList: [],
            index: 0,
            cardId: 0,
            submit: false,
            load: false,
            error: false
        };
    },
    computed: {
        ...mapState("userCentered", ["userCenteredInfo"]),
        ...mapState("favorites", [
            "pictureId",
            "currentPictureFavorite",
            "currentPictureFavoriteId",
            "favoritesId"
        ])
    },
    created() {
        this.get_favorites_list_data();
    },
    mounted() {
        this.$P.$on("createFavoritesName", ({ name, id }) => {
            this.hasFavoritesList = null;
            this.firstCreatList.unshift({ name, id });
            this.hasFavoritesList = "yes";
            this.cardId = this.firstCreatList[0].id;
            this.index = 0;
            if (this.$refs.favorList) {
                this.$refs.favorList.scrollTop = 0;
            }
        });
    },
    beforeDestroy() {},
    methods: {
        ...mapMutations("favorites", [
            "updateFavariteEnterCardShow",
            "updateFavoritesEnterCardName",
            "updateFavoritesId",
            "updatePictureAmount",
            "updateFavoritesStatus"
        ]),
        ...mapMutations("triggerEvtents", [
            "updateGetSchemaData",
            "updateSnackbar"
        ]),
        ...mapMutations("vModal", ["updateOpenPictuerModal"]),
        ...mapMutations("userCentered", ["updateUserCenteredInfo"]),
        async get_favorites_list_data() {
            let { data } = await getFavorites();
            this.firstCreatList = data;
            this.hasFavoritesList = data.length ? "yes" : "no";
            this.init_active_item();
        },
        async save_favorite() {
            //  判断是否为已收藏图片
            if (this.currentPictureFavorite) {
                this.change_favorites();
            } else {
                this.add_favorite();
            }
        },
        //  添加收藏
        async add_favorite() {
            this.submit = true;
            this.load = true;
            try {
                let { data } = await postRequest(
                    `favorites/${this.cardId}/media`,
                    {
                        media_ids: this.pictureId
                    }
                );
                this.newFavoriteId = data.favorite_id;

                // 以下3个都是收藏成功提示弹框使用
                this.updateFavoritesEnterCardName(
                    this.firstCreatList[this.index].name
                );
                this.updateFavoritesId(this.newFavoriteId);
                this.updatePictureAmount(
                    this.firstCreatList[this.index].fav_count + 1
                );

                //  更新当前收藏夹图片数量
                if (this.$route.name === "favorites-details") {
                    let favListData = await getFavorites();
                    let favId = new URL(window.location.href).searchParams.get(
                        "id"
                    );
                    let currentFavData = favListData.data.find(
                        item => item.id == favId
                    );
                    this.currentFavm = currentFavData.fav_count;
                }

                //  更新被收藏图片的状态
                this.updateFavoritesStatus({
                    pictureId: this.pictureId,
                    favoriteId: this.newFavoriteId,
                    m_count: this.currentFavm,
                    isFavor: 1,
                    status: "change"
                });

                this.load = this.error = false;
                await timeout(800);
                this.updateFavariteEnterCardShow(true);
                this.$P.$emit("closeModal");
            } catch (e) {
                if (e?.response?.status === 400) {
                    this.load = false;
                    this.error = true;
                    alert(e?.response?.data.message);
                }
            }
        },
        async cancel_favorite() {
            try {
                let data = {};
                //  当前收藏夹取消图片
                let favData = await cancelPictureFavorite({
                    media_ids: this.pictureId
                });
                //  获取取消图片后的图片总数
                let userData = await getUserProfile();
                //  区分收藏夹详情页和个人收藏中心
                if (this.$route.name === "favorites") {
                    data = userData.data.profile;
                } else if (this.$route.name === "favorites-details") {
                    data = favData.data;
                }

                this.updateFavoritesStatus({
                    pictureId: this.pictureId,
                    isFavor: 0,
                    m_count: data.m_count,
                    status: "remove"
                });

                this.$P.$emit("closeModal");
                this.updateSnackbar(this.$TL.UnfavoriteSuccessful);
            } catch (e) {
                if (e?.response?.status === 500) {
                    this.updateSnackbar(this.$TL.UnfavouriteFailed);
                }
            }
        },

        open_create_favorites_model() {
            this.$store.state.vModal.isCreateFavoriteDialogShow = true;
        },
        //  默认选中收藏夹
        init_active_item() {
            if (this.currentPictureFavoriteId) {
                this.firstCreatList.map((item, i) => {
                    if (this.currentPictureFavoriteId === item.id) {
                        this.index = i;
                        this.cardId = item.id;
                    }
                });
            } else {
                this.index = 0;
                this.cardId = this.firstCreatList[0].id;
            }
        },
        choice_favor(key, id) {
            this.index = key;
            this.cardId = id;
        },
        //  更换收藏夹
        change_favorites() {
            //  todo 如果 图片的收藏夹ID 和图片ID 相同，则提示，并return
            if (this.currentPictureFavoriteId === this.cardId) {
                this.updateSnackbar(this.$TL.currentPictureInThisFavorite);
            } else {
                this.add_favorite();
            }
        }
    }
};
</script>

<style lang="scss">
.addFavorites {
    .v-dialog {
        width: 400px;
    }
}

.add-favorites {
    padding: 16px 12px;

    .create-favor-box {
        width: 100%;
        height: 330px;
        border: 1px solid rgba(#000, 0.15);
        border-radius: $border-radius;
        margin-top: 24px;
    }

    .loading-box {
        height: 100%;
        @include flex(center, center);

        i {
            animation: rotating 0.8s linear infinite;
            font-size: 40px;
        }
    }

    .first-create-info {
        width: 100%;
        height: 100%;
        @include flex(center, center, wrap);

        .info-box {
            text-align: center;
            p {
                font-size: 14px;
                color: #686868;
                margin-top: 8px;
            }

            .v-btn {
                margin: 40px auto;
            }
        }
    }

    .favor-list {
        height: 100%;
        overflow: hidden;
        .list {
            height: 100%;
            overflow-y: auto;
            padding-bottom: 6px;
        }
        .favor-items {
            border-bottom: 1px solid rgba(#000, 0.15);
            padding: 10px;
            @include flex(center);
            cursor: pointer;
            transition: all 0.3s ease;

            &.active {
                p {
                    color: #2874e5;
                }

                .v-btn__content {
                    background-color: rgba(40, 116, 229, 0.7);
                }
            }

            &:hover {
                background-color: rgba(#2874e5, 0.15);
            }

            &:last-child {
                border-bottom: 0;
            }

            .favor-cover {
                height: 40px;
                width: 48px;
                flex-shrink: 0;
                border-radius: $border-radius;
                position: relative;
                overflow: hidden;
                background: {
                    color: #2874e5;
                    size: cover;
                    repeat: no-repeat;
                    position: center center;
                }

                .v-btn__content {
                    width: 100%;
                    height: 100%;
                    @include flex(center, center);
                }

                i {
                    color: $color-white;
                }
            }

            .f-name {
                font-size: 14px;
                margin: {
                    bottom: 0;
                    left: 12px;
                }
            }
        }
    }

    .operat-btm {
        margin-top: 15px;
        @include flex(center, space-between);

        .cancel-favorite-btn {
            background-color: #ec6060;
            margin-left: auto;
            margin-right: 16px;
            span {
                color: white;
            }
        }

        .save-suss-btn {
            font-size: 12px;

            i {
                font-size: 16px;
            }

            .errors {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                color: #e00d0d;
                background-color: #eae6e6;
            }

            .load {
                animation: rotating 0.8s linear infinite;
            }

            .suss {
                color: #18b827;
            }
        }
    }

    @keyframes rotating {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
}
</style>
